import axiosInstance from "@/axios-instance";

export async function fetchUserReports(keycloakId: string): Promise<string[]> {
  try {
    const response = await axiosInstance.get('/reporting/report_names', {
      params: {
        user_id: keycloakId
      }
    });
    return response.data.reports || [];
  } catch (error) {
    console.error('Failed to fetch user reports:', error);
    throw error;
  }
}

export async function downloadReport(reportName: string): Promise<void> {
  try {
    console.log("Report:", reportName)
    const response = await axiosInstance.get(`/reporting/download_report_pdf`, {
      params: {
        report_name: reportName
      },
      responseType: 'blob' // Important for PDF downloads
    });

    // Fallback filename
    let filename = "report.pdf";

    // Check for the filename in the content-disposition header
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download report:', error);
    throw error;
  }
}
